import { ErrorCode, ErrorName } from 'src/constants';

import { BaseError } from './BaseError';

export class GoogleRecaptchaInitializeError extends BaseError {
  constructor(message: string) {
    super(message, { code: ErrorCode.GOOGLE_RECAPTCHA_INITIALIZE, name: ErrorName.GoogleRecaptchaInitialize });
  }
}
